import { Spacer } from '@loomhq/lens';
import _cloneDeep from 'lodash/cloneDeep';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { LOOM_DEV_URI, LOOM_URI } from 'constants/routes';
import { selectCommentBuckets } from 'selectors/comments';

import AddComment from './add-comment';
import { CommentGroup } from './CommentGroup';

import styles from './styles.module.less';

const AllCommentGroups = ({
  renderCommentBucket,
  scrollToCommentBucketIndex,
  willHighlight,
  drawnOnSharePage,
  scrollContainer,
}) => {
  return (
    <>
      {Object.entries(renderCommentBucket).map(([bucketInd, bucket]) => {
        return (
          <CommentGroup
            key={bucketInd}
            drawnOnSharePage={drawnOnSharePage}
            bucket={bucket}
            bucketInd={bucketInd}
            scrollContainer={scrollContainer}
            willHighlight={willHighlight}
            scrollToCommentBucketIndex={scrollToCommentBucketIndex}
          />
        );
      })}
    </>
  );
};

const CommentsContent = props => {
  const { scrollContainer, drawnOnSharePage } = props;

  const addReplyId = useSelector(state => state.comments.add_reply_id);
  const videoPlayer = useSelector(state => state.video_player);
  const scrollToCommentBucketIndex = videoPlayer.scroll_to_bucket;
  const { record_reply_enabled: recordReplyEnabled } = videoPlayer.video;

  const commentBuckets = useSelector(selectCommentBuckets);
  const commentContentRef = useRef(null);

  const willHighlight = Object.keys(commentBuckets).length > 1;

  function isLoomComment(content) {
    return (
      (content.includes(LOOM_DEV_URI) || content.includes(LOOM_URI)) &&
      content.includes('/share/')
    );
  }

  const [renderCommentBucket, setRenderCommentBucket] = useState({});

  // filter out Loom comments if the owner disabled record reply function
  const filteredComments = useMemo(() => {
    const commentsCopy = _cloneDeep(commentBuckets);

    for (const bucketId in commentsCopy) {
      const newComments = [];
      const oldComments = commentsCopy[bucketId].comments;

      oldComments.map(comment => {
        if (!isLoomComment(comment.content) && comment.replies) {
          const replies = comment.replies.filter(
            reply => !isLoomComment(reply.content)
          );

          comment.replies = replies;
          newComments.push(comment);
        }
      });
      commentsCopy[bucketId].comments = newComments;
    }

    return commentsCopy;
  }, [commentBuckets]);

  useEffect(() => {
    if (recordReplyEnabled) {
      setRenderCommentBucket(commentBuckets);
    } else {
      setRenderCommentBucket(filteredComments);
    }
  }, [commentBuckets, recordReplyEnabled, filteredComments]);

  return (
    <div ref={commentContentRef} className={styles.content}>
      <AllCommentGroups
        renderCommentBucket={renderCommentBucket}
        scrollToCommentBucketIndex={scrollToCommentBucketIndex}
        willHighlight={willHighlight}
        drawnOnSharePage={drawnOnSharePage}
        scrollContainer={scrollContainer}
      />
      {Boolean(!addReplyId) && (
        <>
          <Spacer top="large"></Spacer>
          {!drawnOnSharePage && <AddComment />}
        </>
      )}
    </div>
  );
};

export default CommentsContent;
